<template>
    <base-resource :booking_id="booking_id" :resource="resource" :headers="headers"
                   :element_list="form_content" :additionalSaveOperation="updateBooking" :data-decoration="decor"/>
</template>
<script>
    import BaseResource from '../../../../components/base/Resource'
    import { JOURNEY_OPTIONS } from '../../../../modals/journey'
    import BookingAPI from '../../../../api/booking_api'
    import { BOOKING_STATUS } from "../../../../modals/enums/booking_status"
    import DateTimeHelper from "../../../../helpers/datetime"

    export default {
        name: "JourneyResource",
        props: ['booking_id'],
        components: {
            BaseResource
        },
        data: () => ({
            resource: 'journey',
            headers: [
                { sortable: false, divider: true, align: 'start', text: 'Type', value: 'text' },
                { sortable: false, divider: true, align: 'start', text: 'Date', value: 'date' },
                { sortable: false, divider: true, align: 'start', text: 'Created At', value: 'created_at' },
                { sortable: false, divider: true, align: 'start', text: 'Created By', value: 'created_by' }
            ],
            form_content: [
                { md: '12', id: 'type', label: 'Type', type: 'select', items: JOURNEY_OPTIONS, required: false },
                { md: '12', id: 'date', label: 'Date', type: 'date-picker', required: true },
                { md: '12', id: 'remark', label: 'Remark', type: 'textarea', required: false, validate: false }
            ],
            decor: (items = []) => {
                if(items.length == 0) {
                    return [];
                }
                items.forEach(x => {
                    var {text = ''} = JOURNEY_OPTIONS.find(z => z.value === x.type) || {}
                    x.text = text;
                    x.created_at = DateTimeHelper.getDisplayDate(x.created_at)
                });
            },
            updateBooking: (booking_id, journey = {}) => {
                if(journey == null) {
                    return
                }

                let booking_status;
                if(journey.type === 'booking_cancelled') {
                    booking_status = BOOKING_STATUS.CANCELLED
                } else if(journey.type === 'shipped') {
                    booking_status= BOOKING_STATUS.COMPLETED
                }
                if(booking_status) {
                    const json = {id: booking_id, booking_status}
                    BookingAPI.updateBooking(json)
                }
            }
        })
    }
</script>